(() => {
  'use strict';
  if (window.RWScrollMotion) { window.RWScrollMotion.mount(); return; }
  const nodes = new Set(), complete = new WeakSet(), visible = new Set();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const editor = !!window.Shopify?.designMode;
  const supported = 'IntersectionObserver' in window;
  let frame = 0;
  const off = () => reduced.matches || editor || !supported;
  const reveal = supported ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('scroll-trigger--offscreen');
      complete.add(entry.target);
      reveal.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -50px 0px' }) : null;
  const zoom = supported ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    requestUpdate();
  }) : null;
  function requestUpdate() {
    if (frame || off()) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const updates = [];
      visible.forEach(el => {
        if (!el.isConnected) { forget(el); return; }
        const rect = el.getBoundingClientRect();
        const height = el.offsetHeight;
        const fraction = Math.max(0, Math.min(1, (innerHeight - rect.top) / Math.max(1, innerHeight + height)));
        updates.push([el, 1 + fraction * 0.2]);
      });
      updates.forEach(([el, ratio]) => el.style.setProperty('--zoom-in-ratio', ratio.toFixed(4)));
    });
  }
  function setup(el, index) {
    if (el.closest('[data-rwda]')) return;
    nodes.add(el);
    if (el.hasAttribute('data-cascade')) el.style.setProperty('--animation-order', index);
    if (off()) {
      el.classList.remove('scroll-trigger--offscreen');
      el.classList.add('scroll-trigger--cancel');
      el.style.setProperty('--zoom-in-ratio', '1');
      if (editor) el.classList.add('scroll-trigger--design-mode');
      return;
    }
    el.classList.remove('scroll-trigger--cancel');
    if (el.classList.contains('scroll-trigger') && !complete.has(el)) {
      if (el.getBoundingClientRect().top >= innerHeight - 50) el.classList.add('scroll-trigger--offscreen');
      else { el.classList.remove('scroll-trigger--offscreen'); complete.add(el); }
      if (!complete.has(el)) reveal.observe(el);
    }
    if (el.classList.contains('animate--zoom-in')) zoom.observe(el);
  }
  function mount(scope = document) {
    const list = [...scope.querySelectorAll('.scroll-trigger, .animate--zoom-in')];
    if (scope.matches?.('.scroll-trigger, .animate--zoom-in')) list.unshift(scope);
    list.forEach((el, index) => { if (!nodes.has(el)) setup(el, index); });
    requestUpdate();
  }
  function forget(el) {
    reveal?.unobserve(el); zoom?.unobserve(el);
    visible.delete(el); nodes.delete(el);
  }
  reduced.addEventListener('change', () => {
    reveal?.disconnect(); zoom?.disconnect(); visible.clear();
    cancelAnimationFrame(frame); frame = 0;
    [...nodes].forEach((el, index) => el.isConnected ? setup(el, index) : forget(el));
    requestUpdate();
  });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', e => mount(e.target));
  document.addEventListener('shopify:section:unload', e => {
    [...nodes].forEach(el => { if (e.target.contains(el)) forget(el); });
  });
  document.addEventListener('shopify:section:reorder', requestUpdate);
  window.RWScrollMotion = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
})();